module.exports = __webpack_public_path__ + "img/banner-02.a1f1e569.png";